export default __webpack_public_path__ + "static/health-pharma-drug-lifecycle-d052e259ef8d650a746cb511f4105359.png";